// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import constant from '@/common/constant';
import { Cascader, Message } from 'element-ui';


// import 'element-ui/lib/theme-color/index.css'

Vue.config.productionTip = false




Vue.prototype.$http = axios;
axios.defaults.baseURL = constant.env.BASE_URL;

Vue.use(Cascader)
Vue.prototype.$message = Message;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js